import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faGear, faClock } from '@fortawesome/free-solid-svg-icons';

const SETTING_GROUPS = [
  { title: 'Platform Branding', description: 'Logo, colors, and white-label settings.' },
  { title: 'Security', description: 'Password policy, MFA, session timeouts, IP allowlists.' },
  { title: 'SMTP Defaults', description: 'Default outbound email configuration for all tenants.' },
  { title: 'Default Timezone', description: 'Platform-wide default timezone for new tenants.' },
];

export function PlatformSettingsPage() {
  return (
    <div className="space-y-5">
      <div>
        <h1 className="text-xl font-semibold text-foreground">Platform Settings</h1>
        <p className="mt-0.5 text-sm text-muted-foreground">
          Global configuration for the Service Portal platform
        </p>
      </div>

      <div className="space-y-3">
        {SETTING_GROUPS.map((g) => (
          <div
            key={g.title}
            className="flex items-center justify-between rounded-xl border border-border bg-card p-5"
          >
            <div className="flex items-start gap-3">
              <div className="flex h-9 w-9 shrink-0 items-center justify-center rounded-lg bg-muted">
                <FontAwesomeIcon icon={faGear} className="h-4 w-4 text-muted-foreground" />
              </div>
              <div>
                <p className="text-sm font-medium text-foreground">{g.title}</p>
                <p className="mt-0.5 text-xs text-muted-foreground">{g.description}</p>
              </div>
            </div>
            <div className="flex items-center gap-2 rounded-full border border-border px-3 py-1 text-xs text-muted-foreground">
              <FontAwesomeIcon icon={faClock} className="h-3 w-3" />
              Phase 12.8
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
